import Button from '../Button';
import Modal from '../Modal';

type PushNotificationsPopupDumbProps = {
  handleResponse: (response: 'accept' | 'reject' | 'dismiss') => void;
  isOpen: boolean;
};

export const PushNotificationsPopupDumb = (
  props: PushNotificationsPopupDumbProps
) => {
  const handleCloseModal = () => {
    props.handleResponse('dismiss');
  };

  const handleAccept = () => {
    props.handleResponse('accept');
  };

  const handleReject = () => {
    props.handleResponse('reject');
  };

  const isOpen = props.isOpen;

  return (
    <>
      <Modal
        className="px-4 lg:px-11 py-10"
        controlledOnClose={handleCloseModal}
        isControlledOpen={isOpen}
        render={() => {
          return (
            <div className="text-center mt-2">
              <p className="text-black text-lg font-bold">
                Recibí nuestras notificaciones y mantenete al tanto de las
                últimas novedades de Gran DT.
              </p>
              <div className="flex space-x-2 my-6">
                <Button
                  className="flex-1 !bg-[#EEF2FF] !text-[#3366FF] hover:!bg-[#E5E9FF]"
                  type="button"
                  variant="secondary"
                  onClick={handleReject}
                >
                  NO, GRACIAS
                </Button>
                <Button
                  className="flex-1 !bg-[#3366FF] hover:!bg-[#2952CC]"
                  type="button"
                  variant="primary"
                  onClick={handleAccept}
                >
                  RECIBIR
                </Button>
              </div>
            </div>
          );
        }}
        showCloseButton={true}
        size="xs"
        variant="controlled"
      />
    </>
  );
};
